export const DONATIONSBOX_CURRENCY = "$";
export const DONATIONSBOX_VALUES = [3, 5, 10, 15, 50, 100, 500];
export const BENEFACTOR_EMAIL = "benefactor@couchers.org";
